import { render, staticRenderFns } from "./CardLotto.vue?vue&type=template&id=6203746e&lang=pug"
import script from "./CardLotto.vue?vue&type=script&lang=js"
export * from "./CardLotto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports